import useGetMediaObject from './useGetMediaObject'

export default useGetMediaObject
